/**
 * Formats a call transcript based on the current language.
 * Replaces English speaker labels with translated versions when language is Hebrew.
 */
export function formatTranscript(
	transcript: string | undefined,
	language: string,
): string {
	if (!transcript) return "";

	if (language === "he") {
		return transcript
			.replace(/^Agent:/gm, "סוכן:")
			.replace(/^Caller:/gm, "מתקשר:");
	}

	return transcript;
}

/**
 * Selects transcript content that is safe to render in the customer UI.
 * Legacy `transcript` fields are intentionally excluded because only
 * `formattedTranscript` is guaranteed to have completed PII processing.
 */
export function selectDisplayTranscript(data: {
	transcript?: unknown;
	formattedTranscript?: unknown;
	transcriptEdit?: { text?: unknown } | null;
	isPiiRedacted?: unknown;
	piiProcessing?: { detection?: unknown } | null;
}): string {
	if (
		data.isPiiRedacted !== true &&
		data.piiProcessing?.detection !== "disabled"
	) {
		return "";
	}
	if (typeof data.transcriptEdit?.text === "string") {
		return data.transcriptEdit.text;
	}

	return typeof data.formattedTranscript === "string"
		? data.formattedTranscript
		: "";
}
